import { render, staticRenderFns } from "./MobileQuery.vue?vue&type=template&id=be586d74&"
import script from "./MobileQuery.vue?vue&type=script&lang=js&"
export * from "./MobileQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports